import React, { Component } from "react";
import { withRoutes } from "../../../shared/containers/containerRoutes";
import RouteTripControlPoint from "./RouteTripControlPoint";
import Scrollbars from "react-custom-scrollbars-2";
import styles from "./routeTripsContent.module.scss";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import getDates from "../../../shared/services/date.service";
import { states } from "../../../reducers/queriesStates";

class RouteTripControlPoints extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tripControlPoints: [],
      disableUpdate: true,
    };
  }

  componentDidMount() {
    const { selectedTripId, trip, updateTripControlPoints } = this.props;

    if (selectedTripId !== null && trip !== null) {
      const tripControlPoints = trip !== null ? this.getTripControlPoints(trip.controlPoints) : [];

      this.setState({ tripControlPoints: tripControlPoints, disableUpdate: true });
    }
  }

  setControlPoints(preProps) {
    const { selectedTripId, updateTripControlPoints, dayOff, routes, selectedRouteId } = this.props;

    let route = null;

    if (selectedRouteId !== null) {
      route = routes.filter((x) => {
        return x.id === selectedRouteId;
      })[0];

      if (route == undefined) {
        route = null;
      }
    }

    let trips = [];
    let trip = null;

    if (route !== null) {
      trips = dayOff ? route.dayOffTrips : route.workDayTrips;
      if (selectedTripId !== null) {
        trip = trips.filter((x) => {
          return x.id === selectedTripId;
        })[0];
      }
    }

    if (selectedTripId !== preProps.selectedTripId) {
      const tripControlPoints = trip !== undefined && trip !== null ? this.getTripControlPoints(trip.controlPoints) : [];

      this.setState({ tripControlPoints: tripControlPoints, disableUpdate: true });
    }
  }

  componentDidUpdate(preProps) {
    this.setControlPoints(preProps);
  }

  getTripControlPoints(tripControlPoints) {
    return tripControlPoints.map((point) => {
      return { ...point, time: new Date(1970, 0, 0, point.time.split(":")[0], point.time.split(":")[1], 0) };
    });
  }

  onChangeControilPointTime(id, value) {
    const { tripControlPoints } = this.state;

    const points = tripControlPoints.map((point) => {
      if (point.id === id) {
        return { ...point, time: value };
      }

      return point;
    });

    this.setState({ tripControlPoints: points, disableUpdate: false });
  }

  updateTripControlPoints() {
    const { tripControlPoints, disableUpdate } = this.state;
    const { selectedTripId, selectedRouteId, trip, onUpdateTripControlPoints } = this.props;

    if (selectedTripId !== null && !disableUpdate) {
      const controlPointsUpdateData = {};

      tripControlPoints.forEach((point) => {
        controlPointsUpdateData[`${point.id}`] = getDates.timeStringToUtcString(`${point.time.getHours()}:${point.time.getMinutes()}`);
      });

      const options = {
        tripId: selectedTripId,
        controlPoints: controlPointsUpdateData,
      };

      onUpdateTripControlPoints(options, selectedRouteId, {
        ...trip,
        start: `${getDates.lessTenValue(tripControlPoints[0].time.getHours())}:${getDates.lessTenValue(
          tripControlPoints[0].time.getMinutes()
        )}`,
        end: `${getDates.lessTenValue(tripControlPoints[tripControlPoints.length - 1].time.getHours())}:${getDates.lessTenValue(
          tripControlPoints[tripControlPoints.length - 1].time.getMinutes()
        )}`,
        tripControlPoints: tripControlPoints,
      });
    }

    this.setState({ disableUpdate: true });
  }

  render() {
    const { tripControlPoints, disableUpdate } = this.state;
    const { selectedTripId, trip } = this.props;

    if (selectedTripId === null || trip === null) {
      return <div className={styles.routeTripControlPointsContainer}></div>;
    }

    return (
      <div className={styles.routeTripControlPointsContainer}>
        <ButtonPrimary disabled={disableUpdate} handleClick={this.updateTripControlPoints.bind(this)} title="Обновить расписание" />
        {tripControlPoints.length > 0 ? (
          <Scrollbars style={{ height: "90%" }} autoHide={false} ref="scrollbar">
            {tripControlPoints.map((point) => {
              return <RouteTripControlPoint key={point.id} point={point} onChange={this.onChangeControilPointTime.bind(this)} />;
            })}
          </Scrollbars>
        ) : null}
      </div>
    );
  }
}

export default withRoutes(React.memo(RouteTripControlPoints));
